const aboutURL = "/about/"
const propertiesURL = "/property/"
const commercialPropertiesURL = "/commercial-property/"
const newHomesURL = "/newhomes/"

module.exports = {
  sellURL: "/sell-property/",
  valuationURL: "/valuation/",
  officesURL: "/offices/",
  contactURL: "/contact/",
  createAlertURL: "/create-alert/",
  areaGuidesURL: "/area-guides/",
  sitemapURL: "/sitemap/",
  privacyPolicyURL: "/privacy-policy/",
  termsAndConditionsURL: "/terms-and-conditions/",
  cookiePolicyURL: "/cookie-policy/",
  propertiesURL,
  propertiesSaleURL: `${propertiesURL}for-sale/`,
  propertiesRentURL: `${propertiesURL}to-rent/`,
  commercialPropertiesURL,
  commercialPropertiesSaleURL: `${commercialPropertiesURL}for-sale/`,
  commercialPropertiesRentURL: `${commercialPropertiesURL}to-rent/`,
  newHomesURL,
  newHomesSaleURL: `${newHomesURL}for-sale/`,
  propertyDetailSaleURL: "/property-for-sale/",
  propertyDetailRentURL: "/property-to-rent/",
  commercialPropertyDetailSaleURL: "/commercial-property-for-sale/",
  commercialPropertyDetailRentURL: "/commercial-property-to-rent/",
  newHomeDetailURL: "/newhome/",
  aboutURL,
  teamsURL: "/meet-the-team/",
  newsURL: "/insights/",
  careersURL: "/careers/",
}
